import { Component } from 'react';

class Search extends Component {
  shouldComponentUpdate() {
    return false;
  }

  render() {
    return null;
  }
}

export default Search;
